(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[49163],{

/***/ 49105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Button; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/components/Button/Button.module.scss
var Button_module = __webpack_require__(20195);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
;// CONCATENATED MODULE: ./UI/components/Button/utils/useButton.js







/* harmony default export */ function useButton(_param) {
    var dark = _param.dark, secondary = _param.secondary, href = _param.href, classes = _param.className, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "dark",
        "secondary",
        "href",
        "className"
    ]);
    var Component = href ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", (0,_object_spread/* default */.Z)({
            type: "button"
        }, props));
    };
    var _obj;
    var className = classnames_default()((Button_module_default()).button, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Button_module_default()).secondary, secondary), (0,_define_property/* default */.Z)(_obj, (Button_module_default()).dark, dark), _obj));
    return (0,_object_spread/* default */.Z)({
        Component: Component,
        className: className,
        path: href
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Button/index.jsx






var Button = function(props) {
    var _ref = useButton(props), Component = _ref.Component, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "Component",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restProps), {
        children: children
    }));
};
Button.propTypes = {
    disabled: (prop_types_default()).bool,
    secondary: (prop_types_default()).bool,
    dark: (prop_types_default()).bool,
    onClick: (prop_types_default()).func,
    href: (prop_types_default()).string
};
/* harmony default export */ var components_Button = (Button);


/***/ }),

/***/ 78854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ AttachedFile; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/file-to-array-buffer/index.js
var file_to_array_buffer = __webpack_require__(65379);
var file_to_array_buffer_default = /*#__PURE__*/__webpack_require__.n(file_to_array_buffer);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./utils/uploadUtils.js




var uploadFile = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(signed_url, file, onUploadProgress) {
        var buffer, error;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        file_to_array_buffer_default()(file)
                    ];
                case 1:
                    buffer = _state.sent();
                    return [
                        4,
                        api/* API.uploadFile */.b.uploadFile(signed_url, buffer, onUploadProgress)
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error in the uploadFile function", {
                        error: error
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function uploadFile(signed_url, file, onUploadProgress) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/styles.module.scss
var styles_module = __webpack_require__(18584);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx











var AttachedFile = function(props) {
    var _currentFile = props.currentFile, file = _currentFile.file, signedUrl = _currentFile.signedUrl, handleOnUnpinFile = props.handleOnUnpinFile, updateSelectedFileInfo = props.updateSelectedFileInfo;
    var ref = (0,react.useState)(false), isFileUploaded = ref[0], setIsFileUploaded = ref[1];
    var isMobile = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    (0,react.useEffect)(function() {
        if (isFileUploaded) return;
        uploadFile(signedUrl, file, function() {
            updateSelectedFileInfo(signedUrl);
            setIsFileUploaded(true);
        });
    }, [
        isFileUploaded,
        file,
        signedUrl,
        updateSelectedFileInfo, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).file,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: isMobile ? (0,lodash.truncate)(file.name, {
                    length: 20
                }) : file.name
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                children: (0,helper/* getConvertedFileSize */.IJ)(file.size)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: classnames_default()((styles_module_default()).uploading, (0,_define_property/* default */.Z)({}, (styles_module_default()).successUploading, isFileUploaded)),
                style: {
                    backgroundImage: "url(".concat(helper/* staticImagesUrls.unpinFile */.A6.unpinFile, ")")
                },
                "data-file-name": file.name,
                type: "button",
                onClick: handleOnUnpinFile,
                disabled: !isFileUploaded,
                "aria-label": "Unpin"
            })
        ]
    }, "file/".concat(file.name));
};
AttachedFile.propTypes = {
    currentFile: prop_types_default().shape({
        file: prop_types_default().instanceOf(Object).isRequired,
        signedUrl: (prop_types_default()).string.isRequired
    }).isRequired,
    handleOnUnpinFile: (prop_types_default()).func.isRequired,
    updateSelectedFileInfo: (prop_types_default()).func.isRequired
};


/***/ }),

/***/ 49163:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Forms_FeedbackForm; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/TextField/index.jsx + 1 modules
var TextField = __webpack_require__(79228);
// EXTERNAL MODULE: ./UI/components/Button/index.jsx + 1 modules
var Button = __webpack_require__(49105);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/AttachedFile/index.jsx + 1 modules
var AttachedFile = __webpack_require__(78854);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./utils/api.js
var api = __webpack_require__(29473);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/Upload/utils/useUpload.js




/* harmony default export */ function useUpload(props) {
    var setFiles = props.setFiles, register = props.register, dirtyFields = props.dirtyFields, selectedFiles = props.selectedFiles, formKey = props.formKey;
    var handleFilesChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var files, arrFiles, i, ref, signedUrl, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        files = param.target.files;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            6,
                            ,
                            7
                        ]);
                        arrFiles = [];
                        i = 0;
                        _state.label = 2;
                    case 2:
                        if (!(i < files.length)) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            api/* API.getFileSignedURL */.b.getFileSignedURL(files[i].name)
                        ];
                    case 3:
                        ref = _state.sent(), signedUrl = ref.data;
                        arrFiles.push({
                            file: files[i],
                            signedUrl: signedUrl,
                            isUploaded: false
                        });
                        _state.label = 4;
                    case 4:
                        i += 1;
                        return [
                            3,
                            2
                        ];
                    case 5:
                        setFiles((0,_to_consumable_array/* default */.Z)(selectedFiles).concat((0,_to_consumable_array/* default */.Z)(arrFiles)));
                        return [
                            3,
                            7
                        ];
                    case 6:
                        error = _state.sent();
                        console.error("Error in the handleOnSelectedFilesChange function", {
                            error: error
                        });
                        return [
                            3,
                            7
                        ];
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFilesChange(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnUnpinFile = function(param) {
        var dataset = param.target.dataset;
        setFiles(selectedFiles.filter(function(selectedFile) {
            return selectedFile.file.name !== dataset.fileName;
        }));
    };
    var updateSelectedFileInfo = function(signedUrl) {
        var filesArray = selectedFiles.map(function(file) {
            if (file.signedUrl === signedUrl) {
                file.isUploaded = true;
            }
            return file;
        });
        setFiles((0,_to_consumable_array/* default */.Z)(filesArray));
    };
    return {
        formKey: formKey,
        register: register,
        dirtyFields: dirtyFields,
        selectedFiles: selectedFiles,
        handleFilesChange: handleFilesChange,
        handleOnUnpinFile: handleOnUnpinFile,
        updateSelectedFileInfo: updateSelectedFileInfo
    };
};

// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/Upload/styles.module.scss
var styles_module = __webpack_require__(22539);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/Upload/index.jsx







var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var Upload = function(props) {
    var ref = useUpload(props), register = ref.register, dirtyFields = ref.dirtyFields, selectedFiles = ref.selectedFiles, formKey = ref.formKey, handleFilesChange = ref.handleFilesChange, handleOnUnpinFile = ref.handleOnUnpinFile, updateSelectedFileInfo = ref.updateSelectedFileInfo;
    var inputId = "files_".concat(formKey);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (styles_module_default()).uploadFile,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).attachmentManage,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                        name: "description",
                        register: register,
                        placeholder: "Description *",
                        errorMessage: "Required field",
                        required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.description,
                        attached: true,
                        textarea: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                        htmlFor: inputId,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                type: constants/* SVG_IMAGES_TYPES.attachment */.NL.attachment
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                id: inputId,
                                type: "file",
                                onChange: handleFilesChange,
                                multiple: true,
                                className: (styles_module_default()).hide
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).attachedFiles,
                children: [
                    selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.map(function(file) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AttachedFile/* AttachedFile */.s, {
                            handleOnUnpinFile: handleOnUnpinFile,
                            currentFile: file,
                            updateSelectedFileInfo: updateSelectedFileInfo
                        }, file.signedUrl);
                    }),
                    selectedFiles && !!(selectedFiles === null || selectedFiles === void 0 ? void 0 : selectedFiles.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).moreFilesLink,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                            htmlFor: "".concat(inputId, "/add-more"),
                            children: [
                                "add more files",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                    id: "".concat(inputId, "/add-more"),
                                    type: "file",
                                    onChange: handleFilesChange,
                                    multiple: true,
                                    className: (styles_module_default()).hide
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var FeedbackForm_Upload = (Upload);

// EXTERNAL MODULE: ./node_modules/@material-ui/icons/FlashOnRounded.js
var FlashOnRounded = __webpack_require__(33599);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./redux/apis/dataSending.js
var dataSending = __webpack_require__(56962);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/FormAlert/styles.module.scss
var FormAlert_styles_module = __webpack_require__(97018);
var FormAlert_styles_module_default = /*#__PURE__*/__webpack_require__.n(FormAlert_styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/FormAlert/utils/useAlertProps.js





/* harmony default export */ function useAlertProps() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), sendForm = ref[0], ref1 = ref[1], tmp = ref1.data, sent = (tmp === void 0 ? {} : tmp).sent;
    var handleClose = function() {
        return sendForm({
            isSent: false
        });
    };
    var className = classnames_default()((FormAlert_styles_module_default()).formAlert, (0,_define_property/* default */.Z)({}, (FormAlert_styles_module_default()).isVisible, sent));
    return {
        handleClose: handleClose,
        className: className
    };
};

;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/FormAlert/index.jsx









var FormAlert_Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var FormAlert = function(props) {
    var ref = useAlertProps(props), handleClose = ref.handleClose, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormAlert_Svg, {
                className: (FormAlert_styles_module_default()).closeIcon,
                handleOnClick: handleClose,
                type: constants/* SVG_IMAGES_TYPES.closeSvg */.NL.closeSvg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (FormAlert_styles_module_default()).container,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            className: (FormAlert_styles_module_default()).text,
                            children: "We have received your request"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography["default"], {
                            className: (FormAlert_styles_module_default()).text,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "We will back in a flash"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FlashOnRounded/* default */.Z, {
                                    color: "primary",
                                    fontSize: "large",
                                    className: (FormAlert_styles_module_default()).flashIcon
                                })
                            ]
                        })
                    ]
                }))
            })
        ]
    });
};
/* harmony default export */ var FeedbackForm_FormAlert = (FormAlert);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/gaMetrics/getGaMetrics.js + 2 modules
var getGaMetrics = __webpack_require__(58260);
// EXTERNAL MODULE: ./utils/pipedrive/pipedriveHelper.js
var pipedriveHelper = __webpack_require__(94813);
// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/utils/data.js
var utils_data = __webpack_require__(56849);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/utils/useFormProps.js













/* harmony default export */ function useFormProps(_param) {
    var className = _param.className, isBudgetSlider = _param.isBudgetSlider, type = _param.type, extraDescription = _param.extraDescription, restProps = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "isBudgetSlider",
        "type",
        "extraDescription"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)((0,dataSending/* useSendContactFormMutation */.O9)({
        fixedCacheKey: dataSending/* CONTACT_CASH_KEY */.jx
    }), 2), sendForm = ref[0], ref1 = ref[1], isLoading = ref1.isLoading, isError = ref1.isError;
    var ref2 = (0,react.useState)(false), isButtonDisabled = ref2[0], setButtonState = ref2[1];
    var ref3 = (0,react.useState)(false), isSuccess = ref3[0], setIsSuccess = ref3[1];
    var ref4 = (0,index_esm/* useForm */.cI)(), register = ref4.register, handleSubmit = ref4.handleSubmit, reset = ref4.reset, getValues = ref4.getValues, dirtyFields = ref4.formState.dirtyFields;
    var ref5 = (0,react.useState)((0,helper/* addThousandsSeparators */.d8)(utils_data/* budget.min */.F.min)), budget = ref5[0], setBudget = ref5[1];
    var ref6 = (0,react.useState)([]), selectedFiles = ref6[0], setFiles = ref6[1];
    var sliderOptions = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, utils_data/* budget */.F), {
        defaultValue: utils_data/* budget.min */.F.min,
        step: 20000,
        onChange: function(event, value) {
            return setBudget((0,helper/* addThousandsSeparators */.d8)(value));
        },
        marks: utils_data/* marks */.E
    });
    var submitHandler = handleSubmit(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(values, event) {
            var sourceMetrics, attachments, personCountry, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setButtonState(true);
                        sourceMetrics = (0,getGaMetrics/* default */.Z)();
                        attachments = selectedFiles.map(function(file) {
                            return file.signedUrl;
                        });
                        return [
                            4,
                            (0,pipedriveHelper/* getPersonCountry */.Y)()
                        ];
                    case 1:
                        personCountry = _state.sent();
                        if (!(typeof personCountry !== "undefined")) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            sendForm((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, values), {
                                attachments: attachments,
                                projectBudget: budget || "",
                                description: extraDescription ? "".concat(values.description, " ").concat(extraDescription) : values.description,
                                source: sourceMetrics === null || sourceMetrics === void 0 ? void 0 : sourceMetrics.source,
                                medium: sourceMetrics === null || sourceMetrics === void 0 ? void 0 : sourceMetrics.medium,
                                city: personCountry === null || personCountry === void 0 ? void 0 : personCountry.city,
                                clientCityRegion: "".concat(personCountry === null || personCountry === void 0 ? void 0 : personCountry.city, ", ").concat(personCountry === null || personCountry === void 0 ? void 0 : personCountry.region),
                                clientCountry: personCountry === null || personCountry === void 0 ? void 0 : personCountry.country_name
                            }))
                        ];
                    case 2:
                        data = _state.sent().data;
                        if (data.isSuccess) {
                            setIsSuccess(data.isSuccess);
                            setButtonState(false);
                            setFiles([]);
                            setBudget((0,helper/* addThousandsSeparators */.d8)(utils_data/* budget.min */.F.min));
                            reset({
                                name: "",
                                email: "",
                                description: "",
                                phone: ""
                            });
                        }
                        _state.label = 3;
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function(values, event) {
            return _ref.apply(this, arguments);
        };
    }());
    var isValid = function() {
        var ref = getValues(), description = ref.description, email = ref.email;
        return !!description && !!email;
    };
    return (0,_object_spread/* default */.Z)({
        type: type,
        register: register,
        submitHandler: submitHandler,
        dirtyFields: dirtyFields,
        sliderOptions: sliderOptions,
        budget: budget,
        selectedFiles: selectedFiles,
        setFiles: setFiles,
        isBudgetSlider: isBudgetSlider,
        isValid: isValid,
        contactFormError: isError,
        isDataSubmitted: isSuccess,
        isLoading: isLoading,
        className: className,
        isButtonDisabled: isButtonDisabled
    }, restProps);
};

// EXTERNAL MODULE: ./UI/components/Forms/FeedbackForm/styles.module.scss
var FeedbackForm_styles_module = __webpack_require__(25867);
var FeedbackForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(FeedbackForm_styles_module);
;// CONCATENATED MODULE: ./UI/components/Forms/FeedbackForm/index.jsx













var FeedbackForm_Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var BudgetSlider = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 56072).then(__webpack_require__.bind(__webpack_require__, 56072));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56072)
            ];
        }
    }
});
var additionalInfo = [
    "Our experts will analyze your requirements and contact you within 1-2 business days.",
    "Our team will collect all requirements for your project, and if needed, we will sign an NDA to ensure the highest level of privacy.",
    "We will develop a comprehensive proposal and an action plan for your project with estimates, timelines, CVs, etc.", 
];
var FeedbackForm = function(props) {
    var ref = useFormProps(props), className = ref.className, submitHandler = ref.submitHandler, register = ref.register, dirtyFields = ref.dirtyFields, sliderOptions = ref.sliderOptions, budget = ref.budget, isBudgetSlider = ref.isBudgetSlider, setFiles = ref.setFiles, selectedFiles = ref.selectedFiles, type = ref.type, contactFormError = ref.contactFormError, isLoading = ref.isLoading, buttonTitle = ref.buttonTitle, withoutAdditionalInfo = ref.withoutAdditionalInfo, children = ref.children, isValid = ref.isValid, formContainer = ref.formContainer, formHeader = ref.formHeader, isButtonDisabled = ref.isButtonDisabled;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((FeedbackForm_styles_module_default()).formContainer, formContainer),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                className: classnames_default()((FeedbackForm_styles_module_default()).form, (FeedbackForm_styles_module_default())[type], className),
                onSubmit: submitHandler,
                children: [
                    !!formHeader && formHeader,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm_FormAlert, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                            name: "name",
                            register: register,
                            placeholder: "Name *",
                            errorMessage: "Required field",
                            required: dirtyFields.name
                        })
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (FeedbackForm_styles_module_default()).inputsWrapper,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    name: "phone",
                                    register: register,
                                    placeholder: "Phone number",
                                    errorMessage: "Incorrect phone number",
                                    type: "tel"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                    name: "email",
                                    register: register,
                                    placeholder: "Email *",
                                    errorMessage: "Incorrect email address",
                                    required: dirtyFields === null || dirtyFields === void 0 ? void 0 : dirtyFields.email,
                                    type: "email"
                                })
                            ]
                        })
                    })),
                    isBudgetSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(BudgetSlider, {
                        budget: budget,
                        sliderOptions: sliderOptions
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm_Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackForm_Upload, {
                            register: register,
                            dirtyFields: dirtyFields,
                            setFiles: setFiles,
                            selectedFiles: selectedFiles,
                            formKey: type
                        })
                    })),
                    contactFormError && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (FeedbackForm_styles_module_default()).errorMessage,
                        children: "There was an error trying to send your message. Please try again later"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button["default"], {
                        type: "submit",
                        disabled: isButtonDisabled || !isValid(),
                        className: (FeedbackForm_styles_module_default()).formButton,
                        children: buttonTitle || "Contact Us"
                    })
                ]
            }),
            !withoutAdditionalInfo && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (FeedbackForm_styles_module_default()).additionalInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (FeedbackForm_styles_module_default()).title,
                        children: "What's next?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: additionalInfo.map(function(text, i) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (FeedbackForm_styles_module_default()).item,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: i + 1
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: text
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            }),
            children
        ]
    });
};
FeedbackForm.defaultProps = {
    isBudgetSlider: false,
    type: ""
};
FeedbackForm.propTypes = {
    isBudgetSlider: (prop_types_default()).bool,
    type: (prop_types_default()).string
};
/* harmony default export */ var Forms_FeedbackForm = (FeedbackForm);


/***/ }),

/***/ 56849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ marks; },
/* harmony export */   "F": function() { return /* binding */ budget; }
/* harmony export */ });
var budget = {
    min: 0,
    max: 1000000
};
var marks = [
    {
        value: budget.min,
        label: "$ 0"
    },
    {
        value: budget.max,
        label: "$ 1,000,000"
    }, 
];


/***/ }),

/***/ 20195:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__uIelC","secondary":"Button_secondary__2AQtd","dark":"Button_dark__n_Cmy"};

/***/ }),

/***/ 97018:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"formAlert":"styles_formAlert__zSIr1","container":"styles_container___9SyK","text":"styles_text__icV5B","closeIcon":"styles_closeIcon__UJ9w6","flashIcon":"styles_flashIcon__Fcne_","isVisible":"styles_isVisible__Pyxfl"};

/***/ }),

/***/ 18584:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"file":"styles_file__Wn8Kr","uploading":"styles_uploading__cx3iV","successUploading":"styles_successUploading__Wg3zy"};

/***/ }),

/***/ 22539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"uploadFile":"styles_uploadFile__VFDXO","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__YxFAm","attachmentManage":"styles_attachmentManage__o3Wt7","attachedFiles":"styles_attachedFiles__0mEpk","moreFilesLink":"styles_moreFilesLink__fg8TE","hide":"styles_hide__j14FJ"};

/***/ }),

/***/ 25867:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__vCBOF","inputsWrapper":"styles_inputsWrapper__xWZzl","errorMessage":"styles_errorMessage__Ssl09","formButton":"styles_formButton__EDS_f","formContainer":"styles_formContainer__iW9bo","additionalInfo":"styles_additionalInfo__50wNx","title":"styles_title__qnM7x","item":"styles_item__hTlC_","seven-pm-thursday":"styles_seven-pm-thursday__4OGAD","fernwayer":"styles_fernwayer__0cLj2","hotel-data-cloud":"styles_hotel-data-cloud__HDSlx","separate-us":"styles_separate-us__gO4_K","famlicious":"styles_famlicious__n9DJs","natp":"styles_natp__WJMs1","travel-trivia":"styles_travel-trivia__4uKCU","cash-chat":"styles_cash-chat___eYVB","ubichat":"styles_ubichat__0nskq","writer-chrome-extension":"styles_writer-chrome-extension__S_uyH","marketplace-for-clairvoyant-services":"styles_marketplace-for-clairvoyant-services__u3jFZ","fusion-markets":"styles_fusion-markets__hQ9_K","beautonomy":"styles_beautonomy__SmpMX","meateater":"styles_meateater__ErzGl","telemojo":"styles_telemojo__ithLH","blackbird":"styles_blackbird__XgBuf","fintech-app-for-credit-score":"styles_fintech-app-for-credit-score__T793X","smartcenter":"styles_smartcenter__0KpGv","dindon":"styles_dindon__0Ns2r","humankind":"styles_humankind__f9bTi","cinnabar":"styles_cinnabar__GFq1F","machine-learning-in-real-estate":"styles_machine-learning-in-real-estate__tQd9Z","mobile-bank-application":"styles_mobile-bank-application__u9v7v","software-for-mri-interpretation":"styles_software-for-mri-interpretation__Cjz_t","mobile-budgeting-app":"styles_mobile-budgeting-app__7PBnd"};

/***/ })

}]);